"use strict";

const Scrollers = () => {
    const init = () => {
        $(function () {
            $('a[href^="#"]').on('click', function(e){
                var hash = $(this).attr('href').replace('#', '');
                var $target = $('[data-hash="'+hash+'"]');
                var $popout = $('.js-popout[data-popout="'+hash+'"]');
                
                if($target.length && $target.is(':visible')){
                    e.preventDefault();
                    $('html, body').animate({
                        scrollTop: $target.offset().top
                    }, 100);
                }else if($popout.length){
                    $popout.addClass('open');
                }
            });

            $('.js-scrolldown').on('click', function(e){
                $('html, body').animate({
                    scrollTop: $(this).parents('.module-banner-home').next().offset().top
                }, 100);
            });
        });
    };
    
    return {
        init: init
    };
};

export default Scrollers;